import { State } from './types';

/** parent select */
export const catalogPreviewsSelector = (state: State) => state.catalogs.catalogPreviews;

export const selectCatalogPreviews = (state: State) =>
  catalogPreviewsSelector(state).catalogPreviews;
export const selectCatalogPreviewsLoading = (state: State) =>
  catalogPreviewsSelector(state).isLoading;
export const selectCatalogPreviewsError = (state: State) => catalogPreviewsSelector(state).isError;
